import React, {Fragment, useState} from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TituloConIcono from 'components/tituloConIcono';
import { TablaPersonalizada } from 'components';
import { functions } from 'constantes/functions';

const ObservacionesDeLaSolicitud = ({datosGeneralesDeSolicitud}) => {
  const [header] = useState([
    { title: 'Estado anterior', field: 'estadoAnterior', width: '15%'},
    { title: 'Estado nuevo', field: 'estadoNuevo', width: '15%'},
    {
      title: 'Observacion',
      field: 'observacion',
      width: '70%',
      cellStyle: {
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
        textAlign: 'justify',
      },
      render: rowData => rowData?.observacion || '',
    },
  ]);

  return (
    <Fragment>
      <TituloConIcono title={"Observaciones de la solicitud"} icon={""} mostrarBotones={false} mostrarTiempo={false} />
      <Card>
          <CardContent>
            <TablaPersonalizada
                data={functions.ordenarArreglo(datosGeneralesDeSolicitud?.registroDeModificacionesASolicitud || [], 'id')?.reverse()}
                title={"Listado de observaciones"}
                header={header}
                refreshList={undefined}
                addRegister={undefined}
                pageSize={10}
                nombreToolTip={"Agregar nueva registro "}
            />
          </CardContent>
      </Card>
      </Fragment>
  );
}

export default ObservacionesDeLaSolicitud;